var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/tag-input/tag.tsx";
import React from 'react';
import IconButton from '../icon-button/icon-button';
import Text from '../text/text';

/** A single editable Tag (used by TagInput). */
const Tag = _ref => {
  let {
    tag,
    onDelete
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-flex p-1 rounded bg-primary-500 items-center whitespace-nowrap",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }, tag), /*#__PURE__*/React.createElement(IconButton, {
    iconClassName: "w-4 h-4",
    src: require('@tabler/icons/x.svg'),
    onClick: () => onDelete(tag),
    transparent: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }));
};

export default Tag;